module.exports = __webpack_public_path__ + "static/Callouttile-c1cd1f000bd0c41aa2619b86779b10ba.png";